import { render, staticRenderFns } from "./modal-resposta-rapida.vue?vue&type=template&id=cb0cd03e&"
import script from "./modal-resposta-rapida.vue?vue&type=script&lang=js&"
export * from "./modal-resposta-rapida.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb0cd03e')) {
      api.createRecord('cb0cd03e', component.options)
    } else {
      api.reload('cb0cd03e', component.options)
    }
    module.hot.accept("./modal-resposta-rapida.vue?vue&type=template&id=cb0cd03e&", function () {
      api.rerender('cb0cd03e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/atendimento/modal/modal-resposta-rapida/modal-resposta-rapida.vue"
export default component.exports